import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { AiListeningApiService } from 'src/services/aiListeningApi'

export const useGetAiListeningSmartInsightsQuery = (
  campaignId: string,
  checkedAt?: string
) => {
  return useQuery({
    enabled: !!campaignId,
    queryFn: () =>
      AiListeningApiService.getSmartInsights(campaignId, checkedAt),
    queryKey: [
      QueryKey.GET_AI_LISTENING_CAMPAIGN_SMART_INSIGHTS,
      campaignId,
      checkedAt,
    ],
  })
}
